<!--
 * @Author: your name
 * @Date: 2020-07-29 11:51:28
 * @LastEditTime: 2020-07-29 18:33:15
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/lib/ui/components/form/form-id-card-input/form-id-card-input.vue
-->
<template>
  <div class="form-id-card-input form-item">
    <x-proxy-form-item
    :showRequired="showRequired"
    :label="widget.label"
    :processTitle="widget.processTitle"
    :validatorRules="validatorRules"
    :validateKey="validateKey"
    :validateInfo="validateInfo"
    :disabled="widget.readOnly">
      <cube-input
        v-if="renderSence === 'edit'"
        v-model="formValue"
        :disabled="widget.readOnly"
        :placeholder="widget.readOnly ? '' : widget.placeholder"
        :maxlength="maxLength"
        :tabindex="tabindex"
      ></cube-input>
      <input v-else-if="renderSence === 'read'" class="cube-input-field text-overflow" readonly :value="formValue || '-'" />
    </x-proxy-form-item>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import WidgetIdCardValidator from '../../../form-validator/widget-id-card-validator'
import WidgetPassPortCardValidator from '../../../form-validator/widget-pass-port-card-validator'
import WidgetHkCardValidator from '../../../form-validator/widget-hk-card-validator'
import WidgetTwCardValidator from '../../../form-validator/widget-tw-card-validator'

export default {
  name: 'FormIdcardInput',
  mixins: [FormWidgetConfigMixin],
   data() {
    return {
      maxLength: undefined
    }
  },
  watch: {
    'widget.idCardType': {
      handler(newValue, oldValue) {
        this.maxLength = undefined
        if (newValue === 'IDCard') {
          this.widgetRules = [this._validate(WidgetIdCardValidator(`格式错误`))]
          this.maxLength = 18
        } else if (newValue === 'PassPortCard') {
          this.widgetRules = [this._validate(WidgetPassPortCardValidator(`护照格式错误`))]
        } else if (newValue === 'HKCard') {
          this.widgetRules = [this._validate(WidgetHkCardValidator(`港澳通行证格式错误`))]
        } else if (newValue === 'TWCard') {
          this.widgetRules = [this._validate(WidgetTwCardValidator(`台湾通行证格式错误`))]
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">

</style>